export default "__VITE_ASSET__fcd989f3__"